var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptionGray({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2441 1.59668C14.33 0.966914 15.67 0.966914 16.7559 1.59668L21.2363 4.19629L21.2383 4.19727L25.7295 6.77734C26.8181 7.40289 27.4879 8.56378 27.4854 9.81934L27.4746 14.999V15.001L27.4854 20.1807C27.4879 21.4362 26.8181 22.5971 25.7295 23.2227L21.2383 25.8027L21.2363 25.8037L16.7559 28.4033C15.67 29.0331 14.33 29.0331 13.2441 28.4033L8.76367 25.8037L8.76172 25.8027L4.27051 23.2227C3.18188 22.5971 2.51207 21.4362 2.51465 20.1807L2.52539 15.001V14.999L2.51465 9.81934C2.51207 8.56378 3.18188 7.40289 4.27051 6.77734L8.76172 4.19727L8.76367 4.19629L13.2441 1.59668Z",
    fill: "white",
    stroke: "#A7A7A7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30_1486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.185 11.4585C14.5837 10.8979 15.4163 10.8979 15.815 11.4585L17.7389 14.1641C18.0647 14.6223 18.7041 14.7219 19.1539 14.3846L20.3653 13.476C21.1046 12.9215 22.1361 13.5808 21.9433 14.4847L21.0022 18.8961C20.9037 19.3576 20.496 19.6875 20.0242 19.6875H9.97584C9.50396 19.6875 9.09629 19.3576 8.99784 18.8961L8.05673 14.4847C7.86391 13.5808 8.89536 12.9215 9.63473 13.476L10.8461 14.3846C11.2959 14.7219 11.9353 14.6223 12.2611 14.1641L14.185 11.4585Z",
    fill: "url(#paint0_linear_30_1486)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_30_1486",
    x1: 15,
    y1: 10.3125,
    x2: 15,
    y2: 19.6875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFDFDF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30_1486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(7.5 7.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionGray);
export default __webpack_public_path__ + "static/media/subscriptionGray.f0ef24ac0a684ee45505ffc904518f8a.svg";
export { ForwardRef as ReactComponent };